module.exports = __webpack_public_path__ + "static/media/Aniketh.b804f864.png";